<!-- // 0 Left selection bar outside two handles -->
<span class="range-slider-span range-slider-bar-wrapper range-slider-left-out-selection"
      #leftOuterSelectionBar
      rangeSliderElement>
      <span class="range-slider-span range-slider-bar"></span>
</span>
<!-- // 1 Right selection bar outside two handles -->
<span class="range-slider-span range-slider-bar-wrapper range-slider-right-out-selection"
      #rightOuterSelectionBar
      rangeSliderElement>
      <span class="range-slider-span range-slider-bar"></span>
</span>
<!-- // 2 The whole slider bar -->
<span class="range-slider-span range-slider-bar-wrapper range-slider-full-bar"
      [class.range-slider-transparent]="fullBarTransparentClass"
      #fullBar
      rangeSliderElement>
      <span class="range-slider-span range-slider-bar"></span>
</span>
<!-- // 3 Selection bar between two handles -->
<span class="range-slider-span range-slider-bar-wrapper range-slider-selection-bar"
      [class.range-slider-draggable]="selectionBarDraggableClass"
      #selectionBar
      rangeSliderElement>
      <span class="range-slider-span range-slider-bar range-slider-selection"
            [ngStyle]="barStyle"></span>
</span>
<!-- // 4 Low slider handle -->
<span class="range-slider-span range-slider-pointer range-slider-pointer-min"
      [ngStyle]="minPointerStyle"
      #minHandle
      rangeSliderHandle></span>
<!-- // 5 High slider handle -->
<span class="range-slider-span range-slider-pointer range-slider-pointer-max"
      [ngStyle]="maxPointerStyle"
      [style.display]="range ? 'inherit' : 'none'"
      #maxHandle
      rangeSliderHandle></span>
<!-- // 6 Floor label -->
<span class="range-slider-span range-slider-bubble range-slider-limit range-slider-floor"
      #floorLabel
      rangeSliderLabel></span>
<!-- // 7 Ceiling label -->
<span class="range-slider-span range-slider-bubble range-slider-limit range-slider-ceil"
      #ceilLabel
      rangeSliderLabel></span>
<!-- // 8 Label above the low slider handle -->
<span class="range-slider-span range-slider-bubble range-slider-model-value"
      #minHandleLabel
      rangeSliderLabel></span>
<!-- // 9 Label above the high slider handle -->
<span class="range-slider-span range-slider-bubble range-slider-model-high"
      #maxHandleLabel
      rangeSliderLabel></span>
<!-- // 10 Combined range label when the slider handles are close ex. 15 - 17 -->
<span class="range-slider-span range-slider-bubble range-slider-combined"
      #combinedLabel
      rangeSliderLabel></span>
<!-- // 11 The ticks -->
<span class="range-slider-ticks"
      [class.range-slider-ticks-values-under]="ticksUnderValuesClass"
      [hidden]="!showTicks"
      #ticksElement
      rangeSliderElement>
      <span *ngFor="let t of ticks"
            class="range-slider-tick"
            [class.range-slider-selected]="t.selected"
            [ngStyle]="t.style">
            <range-slider-tooltip-wrapper [template]="tooltipTemplate"
                                          [tooltip]="t.tooltip"
                                          [placement]="t.tooltipPlacement"></range-slider-tooltip-wrapper>
            <range-slider-tooltip-wrapper *ngIf="t.value != null"
                                          class="range-slider-span range-slider-tick-value"
                                          [template]="tooltipTemplate"
                                          [tooltip]="t.valueTooltip"
                                          [placement]="t.valueTooltipPlacement"
                                          [content]="t.value"></range-slider-tooltip-wrapper>
            <span *ngIf="t.legend != null"
                  class="range-slider-span range-slider-tick-legend"
                  [innerHTML]="t.legend"></span>
      </span>
</span>